import useTranslation from "../CustomHooks/useTranslation";
import Image from "../images/Image";
import { emptyScreenContent } from "./EmptyScreenContent";

export default function AccessDeniedScreen() {
    const { translate } = useTranslation(emptyScreenContent);
    return (
        <div className="flex flex-col items-center relative top-80 justify-center p-4 h-10">
            {/* Image container */}
            <Image
                src={'access_denied'}
                className={` w-fit object-cover`}
                testId="empty-screen-image"
            />
            {/* Heading */}
            <h1 className="text-heading3 text-primary_text text-center pt-5 pb-1 text-base sm:text-lg md:text-xl lg:text-2xl">
                {translate('You don’t have access to this page.')}
            </h1>
            {/* Subheading */}
            <p className="text-secondary_text text-body2 text-center text-sm sm:text-base md:text-lg">
                {translate('Reach out to an administrator for permission ')}
            </p>
        </div>
    );
}
